<template>
  <div>
    <BaseTitle :title="$t('content.modules')" :yearPeriode="titleData" />

    <v-card>
      <div class="text-center"></div>
      <div>
        <div class="pa-5 d-flex justiy-space-between align-items section-header active">
          <div class="student-title">{{ $t('content.modules') }}</div>
        </div>
        <div class="ml-5 mt-3 mr-5">
          <div class="d-flex align-center justify-space-between">
            <div>
              <v-btn
                color="primary"
                class="btn-primary-custom mb-2 mb-md-0 mr-md-2"
                v-if="
                  (isStudent === false && permissionButton('ROLE_MODULE_VIEW')) || (isStudent === false && permissionButton('ROLE_MODULE_LITE_VIEW'))
                "
                @click="addModules()"
                >{{ $t('add') }}</v-btn
              >
            </div>

            <v-progress-circular class="text-center" v-if="loadingLoad === true" indeterminate color="primary"></v-progress-circular>
            <div>
              <v-text-field v-model="search" :label="$t('search')" @input="getData">
                <template #prepend-inner>
                  <svg-icon icon="ic-search" class="primary--text mr-3" />
                </template>
              </v-text-field>
            </div>
          </div>
        </div>
        <div class="border-item">
          <!-- content -->

          <!-- teacher modules -->
          <draggable
            v-if="!isStudent"
            :list="datas"
            :animation="200"
            ghost-class="moving-card"
            group="datas"
            filter=".action-button"
            class="w-full max-w-md"
            tag="ul"
            @end="changeOrder"
          >
            <div class="pa-4 ml-4 mr-4 mb-4" v-for="item in datas" :key="item.moduleId">
              <div class="bg-col">
                <slide-box :value="false">
                  <template #activator="{isOpen}">
                    <v-row>
                      <v-col md="1">
                        <div class="d-inline d-flex pa-4 justify-center">
                          <v-icon
                            color="orange"
                            v-if="
                              (isStudent === true && item.locked === false) ||
                                (isStudent === false && item.locked === false) ||
                                (isStudent === false && item.locked === true)
                            "
                            >{{ isOpen ? 'mdi-chevron-down' : 'mdi-chevron-right' }}</v-icon
                          >
                        </div>
                      </v-col>
                      <v-col md="10" class="mt-3">
                        <div class="d-block">
                          <h3 class="d-inline">
                            <span class="header-content">{{ item.moduleName }} </span>
                          </h3>
                        </div>
                        <div class="d-block mt-2">
                          <div class="d-flex d-inline">
                            <span class="mr-3"> {{ $t('form.status') }} : </span>
                            <svg-icon v-if="item.locked === true" icon="lock" class="red--text assigment-icon" />
                            <svg-icon v-if="item.locked === false" icon="gembok" class="assigment-icon" />
                            <v-divider vertical class="ml-6 mr-6" />
                            <span class="mr-3"> {{ $t('content.available_from') }} : </span>
                            <h4 class="grey--text text-lighten-2" v-if="item.availableFrom">{{ item.availableFrom }}</h4>
                            <h4 class="grey--text text-lighten-2" v-else>-</h4>
                            <v-divider vertical class="ml-6 mr-6" />
                            <div v-if="item.locked === false">
                              <span class="mr-3">{{ $t('content.lock_schedule') }} : </span>
                              <strong style="color: #E02020;">{{ item.schedule }}</strong>
                              <strong style="color: #E02020;" v-if="item.schedule === null">-</strong>
                            </div>
                            <div v-if="item.locked === true">
                              <span class="mr-3">{{ $t('content.unlock_schedule') }} : </span>
                              <strong style="color: #6DD400;">{{ item.schedule }}</strong>
                              <strong style="color: #6DD400;" v-if="item.schedule === null">-</strong>
                            </div>
                          </div>
                        </div>
                        <div class="d-flex"></div>
                      </v-col>
                      <v-col md="1" v-if="isStudent === false">
                        <template>
                          <div class="pa-5">
                            <v-menu offset-y>
                              <template v-slot:activator="{ on, attrs }">
                                <span dark v-bind="attrs" v-on="on">
                                  <svg-icon icon="ic-moreaction-black" class="mt-1" />
                                </span>
                              </template>
                              <v-list>
                                <!-- <v-list-item>
                                <v-list-item-title class="text-dropdown" @click="goView(item.moduleId)">{{ $t('view') }}</v-list-item-title>
                              </v-list-item> -->
                                <v-list-item v-if="permissionButton('ROLE_MODULE_UPDATE') || permissionButton('ROLE_MODULE_LITE_UPDATE')">
                                  <v-list-item-title class="text-dropdown" @click="goEdit(item.moduleId)">{{ $t('edit') }}</v-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="permissionButton('ROLE_MODULE_DELETE') || permissionButton('ROLE_MODULE_LITE_DELETE')">
                                  <v-list-item-title class="text-dropdown-delete" @click="goDelete(item)">{{ $t('table.delete') }}</v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </div>
                        </template>
                      </v-col>
                      <v-dialog v-model="dialogDelete" persistent max-width="290">
                        <v-card>
                          <v-card-title class="headline">{{ $t('delete_title') }}</v-card-title>
                          <v-card-text>{{ $t('delete_message') }}</v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn text @click="dialogDelete = false">{{ $t('disagree') }}</v-btn>
                            <v-btn text @click="deleteDetail">{{ $t('aggree') }}</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-row>
                  </template>
                  <template
                    v-if="
                      (isStudent === true && item.locked === false) ||
                        (isStudent === false && item.locked === false) ||
                        (isStudent === false && item.locked === true)
                    "
                  >
                    <v-row>
                      <v-col md="1" align="center"> </v-col>
                      <v-col md="10">
                        <div class="d-block">
                          <span class="d-inline"> <div class="container" v-html="item.description" /> </span>
                        </div>
                        <v-divider class="mb-5" />
                        <div>
                          <!-- File -->
                          <div v-if="item.moduleFiles.length > 0" class="pa-5 mb-5 card-modules">
                            <strong class="header-content ">{{ $t('form.file') }} </strong>
                            <div class="mt-5">
                              <div v-for="moduleFiles in item.moduleFiles" :key="moduleFiles.fileId">
                                <v-divider class="mb-3" />
                                <div class="d-block">
                                  <v-row>
                                    <v-col :md="moduleFiles.lock ? 2 : 1" class="d-flex justify-space-around">
                                      <svg-icon v-if="moduleFiles.lock === true" icon="lock" class="red--text assigment-icon" />
                                      <div v-if="moduleFiles.lock === true" class="divider" />
                                      <svg-icon icon="modules_2" width="30" height="30" class="primary--text" />
                                    </v-col>
                                    <v-col :md="moduleFiles.lock ? 8 : 9">
                                      <span> {{ moduleFiles.fileName }} </span>
                                    </v-col>
                                    <v-col
                                      v-if="
                                        (moduleFiles.lock === false && isStudent === false && permissionButton('ROLE_FILES_VIEW')) ||
                                          (moduleFiles.lock === true && isStudent === false && permissionButton('ROLE_FILES_VIEW')) ||
                                          (moduleFiles.lock === false && isStudent === true && permissionButton('ROLE_FILES_VIEW')) ||
                                          (moduleFiles.lock === false && isStudent === false && permissionButton('ROLE_FILES_LITE_VIEW')) ||
                                          (moduleFiles.lock === true && isStudent === false && permissionButton('ROLE_FILES_LITE_VIEW')) ||
                                          (moduleFiles.lock === false && isStudent === true && permissionButton('ROLE_FILES_LITE_VIEW'))
                                      "
                                      md="2"
                                      class="d-flex justify-space-around"
                                    >
                                      <div @click.prevent="linkDownload(moduleFiles)">
                                        <svg-icon icon="modules_download" width="30" height="30" class="mt-1 pointer" />
                                      </div>
                                      <div class="divider" />
                                      <div @click.prevent="previewFileTeacher(undefined, { moduleFiles })">
                                        <svg-icon icon="modules_view" width="30" height="30" class="mt-1 pointer" />
                                      </div>
                                    </v-col>
                                  </v-row>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- Assignment -->
                          <div v-if="item.moduleAssignments.length > 0" class="pa-5 mb-5 card-modules">
                            <strong class="header-content">{{ $t('menu.assignment') }} </strong>

                            <div class="mt-5">
                              <div v-for="moduleAssignments in item.moduleAssignments" :key="moduleAssignments.moduleAssignmentId">
                                <v-divider class="mb-3" />
                                <div class="d-block">
                                  <v-row>
                                    <v-col md="1" align="center">
                                      <div class="pa-5">
                                        <svg-icon v-if="moduleAssignments.locked === true" icon="lock" class="red--text assigment-icon" />
                                        <svg-icon v-if="moduleAssignments.locked === false" icon="gembok" class="assigment-icon" />
                                      </div>
                                    </v-col>
                                    <v-col md="10">
                                      <div class="d-block mb-2">
                                        <strong class="d-inline" style="font-size: 12px;">
                                          {{ moduleAssignments.assignmentTitle }}
                                        </strong>
                                      </div>
                                      <div class="d-block">
                                        <div>
                                          <span style="font-size: 12px;">
                                            <span class="mr-3">
                                              {{ $t('form.datatype') }}:
                                              <strong style="color:#00BF63;" v-if="moduleAssignments.assignmentTypeId == 4"
                                                >{{ $t('content.assignment_item.manual_input') }}
                                              </strong>
                                              <strong style="color:#00BF63;" v-if="moduleAssignments.assignmentTypeId == 3">{{
                                                $t('content.assignment_item.attendance')
                                              }}</strong>
                                              <strong style="color:#00BF63;" v-if="moduleAssignments.assignmentTypeId == 2">{{
                                                $t('content.assignment_item.quiz')
                                              }}</strong>
                                              <strong style="color:#00BF63;" v-if="moduleAssignments.assignmentTypeId == 1">{{
                                                $t('content.assignment_item.upload_files')
                                              }}</strong>
                                            </span>
                                            <span class="mr-3 ml-3">
                                              | {{ $t('content.available_from') }}:
                                              <strong>{{ moduleAssignments.availableFrom }}</strong>
                                              <strong v-if="moduleAssignments.availableFrom === null">-</strong></span
                                            >
                                            <span v-if="moduleAssignments.locked === false" class="ml-3 mr-3"
                                              >| {{ $t('content.lock_schedule') }} :
                                              <strong style="color: #E02020;">{{ moduleAssignments.availableFrom }}</strong>
                                              <strong style="color: #E02020;" v-if="moduleAssignments.availableFrom === null">-</strong>
                                            </span>
                                            <span v-if="moduleAssignments.locked === true" class="ml-3 mr-3"
                                              >{{ $t('content.unlock_schedule') }} :
                                              <strong style="color: #6DD400;">{{ moduleAssignments.availableFrom }}</strong>
                                              <strong style="color: #6DD400;" v-if="moduleAssignments.availableFrom === null">-</strong>
                                            </span>
                                            <span class="ml-3 mr-3">
                                              | {{ $t('content.due_date') }} :
                                              <strong style="color:#FA6400;">{{ moduleAssignments.dueDate }}</strong>
                                              <strong style="color:#FA6400;" v-if="moduleAssignments.dueDate === null">-</strong>
                                            </span>
                                            <span class="ml-3 mr-3">
                                              <span>| {{ $t('menu.score') }} : </span>
                                              <strong style="color:#00bf63;" v-if="!isStudent"> {{ moduleAssignments.totalPoint }}</strong>
                                              <span
                                                style="color:#00bf63;"
                                                v-if="
                                                  (moduleAssignments.point === 0 && moduleAssignments.published === false && isStudent) ||
                                                    (moduleAssignments.excused && isStudent)
                                                "
                                              >
                                                - / {{ moduleAssignments.totalPoint }} Pts</span
                                              >
                                              <span
                                                style="color:#00bf63;"
                                                v-if="
                                                  (moduleAssignments.point !== 0 && moduleAssignments.published === false && isStudent) ||
                                                    (moduleAssignments.excused && isStudent)
                                                "
                                              >
                                                {{ moduleAssignments.point }} / {{ moduleAssignments.totalPoint }} Pts</span
                                              >
                                            </span>
                                            <span class="ml-3 mr-1" v-if="!isStudent"> | {{ $t('information') }} :</span>
                                            <strong style="color:#6DD400;" v-if="!isStudent && moduleAssignments.published === true">{{
                                              $t('content.publish_score')
                                            }}</strong>
                                            <strong style="color:#E02020;" v-if="!isStudent && moduleAssignments.published === false">
                                              {{ $t('content.unpublish_score') }}</strong
                                            >
                                          </span>
                                        </div>
                                      </div>
                                    </v-col>
                                    <v-col
                                      v-if="
                                        (moduleAssignments.autoLock === false &&
                                          isStudent === false &&
                                          moduleAssignments.locked === false &&
                                          permissionButton('ROLE_ASSIGNMENT_VIEW')) ||
                                          (moduleAssignments.autoLock === true &&
                                            isStudent === false &&
                                            moduleAssignments.locked === false &&
                                            permissionButton('ROLE_ASSIGNMENT_VIEW')) ||
                                          (moduleAssignments.autoLock === false &&
                                            isStudent === false &&
                                            moduleAssignments.locked === true &&
                                            permissionButton('ROLE_ASSIGNMENT_VIEW')) ||
                                          (moduleAssignments.autoLock === false &&
                                            isStudent === true &&
                                            moduleAssignments.locked === false &&
                                            permissionButton('ROLE_ASSIGNMENT_VIEW')) ||
                                          (moduleAssignments.autoLock === false &&
                                            isStudent === false &&
                                            moduleAssignments.locked === false &&
                                            permissionButton('ROLE_ASSIGNMENT_LITE_VIEW')) ||
                                          (moduleAssignments.autoLock === true &&
                                            isStudent === false &&
                                            moduleAssignments.locked === false &&
                                            permissionButton('ROLE_ASSIGNMENT_LITE_VIEW')) ||
                                          (moduleAssignments.autoLock === false &&
                                            isStudent === false &&
                                            moduleAssignments.locked === true &&
                                            permissionButton('ROLE_ASSIGNMENT_LITE_VIEW')) ||
                                          (moduleAssignments.autoLock === false &&
                                            isStudent === true &&
                                            moduleAssignments.locked === false &&
                                            permissionButton('ROLE_ASSIGNMENT_LITE_VIEW'))
                                      "
                                      md="1"
                                      class="pa-5"
                                      align="center"
                                      @click="goViewAssignment(moduleAssignments)"
                                    >
                                      <svg-icon icon="modules_view" width="30" height="30" class="mt-1 pointer" />
                                    </v-col>
                                  </v-row>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- pages -->
                          <div v-if="item.modulePages.length > 0" class="pa-5 mb-5 card-modules">
                            <strong class="header-content">{{ $t('content.pages') }}</strong>

                            <div class="mt-5">
                              <div v-for="modulePages in item.modulePages" :key="modulePages.modulePageId">
                                <v-divider class="mb-3" />
                                <div class="d-block">
                                  <v-row>
                                    <v-col md="1" align="center">
                                      <svg-icon icon="modules_3" width="30" height="30" class="primary--text" />
                                    </v-col>
                                    <v-col md="10">
                                      <span> {{ modulePages.title }} </span>
                                    </v-col>
                                    <v-col
                                      v-if="permissionButton('ROLE_PAGES_VIEW') || permissionButton('ROLE_PAGES_LITE_VIEW')"
                                      md="1"
                                      @click="goViewPages(modulePages.pageId)"
                                    >
                                      <svg-icon icon="modules_view" width="30" height="30" class="mt-1 pointer" />
                                    </v-col>
                                  </v-row>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </template>
                </slide-box>
              </div>
            </div>
          </draggable>

          <!-- student modules -->
          <div class="pa-4 ml-4 mr-4 mb-4" v-for="item in datas" :key="item.moduleId" v-else>
            <div class="bg-col" @click="checkAvailables(item.modulesDetail)">
              <slide-box :value="false">
                <template #activator="{isOpen}">
                  <v-row>
                    <v-col md="1">
                      <div class="d-inline d-flex pa-4 justify-center">
                        <v-icon
                          v-if="
                            (isStudent === true && item.modulesDetail === true && item.locked === false) ||
                              (isStudent === false && item.modulesDetail === true) ||
                              (isStudent === false && item.modulesDetail === true)
                          "
                          color="orange"
                          >{{ isOpen ? 'mdi-chevron-down' : 'mdi-chevron-right' }}</v-icon
                        >
                      </div>
                    </v-col>
                    <v-col md="10" class="mt-3">
                      <div class="d-block">
                        <h3 class="d-inline">
                          <span class="header-content">{{ item.moduleName }} </span>
                        </h3>
                      </div>
                      <div class="d-block mt-2">
                        <div class="d-flex d-inline">
                          <span class="mr-3"> {{ $t('form.status') }} : </span>
                          <svg-icon v-if="item.locked === true" icon="lock" class="red--text assigment-icon" />
                          <svg-icon v-if="item.locked === false" icon="gembok" class="assigment-icon" />
                          <v-divider vertical class="ml-6 mr-6" />
                          <span class="mr-3"> {{ $t('content.available_from') }} : </span>
                          <h4 class="grey--text text-lighten-2" v-if="item.availableFrom">{{ item.availableFrom }}</h4>
                          <h4 class="grey--text text-lighten-2" v-else>-</h4>
                          <!-- <v-divider vertical class="ml-6 mr-6" />
                          <div v-if="item.locked === false">
                            <span class="mr-3">{{ $t('content.lock_schedule') }} : </span>
                            <strong style="color: #E02020;">{{ item.schedule }}</strong>
                            <strong style="color: #E02020;" v-if="item.schedule === null">-</strong>
                          </div> -->
                          <!-- <div v-if="item.locked === true">
                            <span class="mr-3">{{ $t('content.unlock_schedule') }} : </span>
                            <strong style="color: #6DD400;">{{ item.schedule }}</strong>
                            <strong style="color: #6DD400;" v-if="item.schedule === null">-</strong>
                          </div> -->
                        </div>
                      </div>
                      <div class="d-flex"></div>
                    </v-col>
                    <v-col md="1" v-if="isStudent === false">
                      <template>
                        <div class="pa-5">
                          <v-menu offset-y>
                            <template v-slot:activator="{ on, attrs }">
                              <span dark v-bind="attrs" v-on="on">
                                <svg-icon icon="ic-moreaction-black" class="mt-1" />
                              </span>
                            </template>
                            <v-list>
                              <v-list-item v-if="permissionButton('ROLE_MODULE_UPDATE') || permissionButton('ROLE_MODULE_LITE_UPDATE')">
                                <v-list-item-title class="text-dropdown" @click="goEdit(item.moduleId)">{{ $t('edit') }}</v-list-item-title>
                              </v-list-item>
                              <v-list-item v-if="permissionButton('ROLE_MODULE_DELETE') || permissionButton('ROLE_MODULE_LITE_DELETE')">
                                <v-list-item-title class="text-dropdown-delete" @click="goDelete(item)">{{ $t('table.delete') }}</v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </div>
                      </template>
                    </v-col>
                    <v-dialog v-model="dialogDelete" persistent max-width="290">
                      <v-card>
                        <v-card-title class="headline">{{ $t('delete_title') }}</v-card-title>
                        <v-card-text>{{ $t('delete_message') }}</v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn text @click="dialogDelete = false">{{ $t('disagree') }}</v-btn>
                          <v-btn text @click="deleteDetail">{{ $t('aggree') }}</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-row>
                </template>
                <template
                  v-if="
                    (isStudent === true && item.modulesDetail === true && item.locked === false) ||
                      (isStudent === false && item.modulesDetail === true) ||
                      (isStudent === false && item.modulesDetail === true)
                  "
                >
                  <v-row>
                    <v-col md="1" align="center"> </v-col>
                    <v-col md="10">
                      <div class="d-block">
                        <span class="d-inline"> <div class="container" v-html="item.description" /> </span>
                      </div>
                      <v-divider class="mb-5" />
                      <div>
                        <!-- File -->
                        <div v-if="item.moduleFiles.length > 0" class="pa-5 mb-5 card-modules">
                          <strong class="header-content ">{{ $t('form.file') }} </strong>
                          <div class="mt-5">
                            <div v-for="moduleFiles in item.moduleFiles" :key="moduleFiles.fileId">
                              <v-divider class="mb-3" />
                              <div class="d-block">
                                <v-row>
                                  <v-col :md="moduleFiles.lock ? 2 : 1" class="d-flex justify-space-around">
                                    <svg-icon v-if="moduleFiles.lock === true" icon="lock" class="red--text assigment-icon" />
                                    <div v-if="moduleFiles.lock === true" class="divider" />
                                    <svg-icon icon="modules_2" width="30" height="30" class="primary--text" />
                                  </v-col>
                                  <v-col :md="moduleFiles.lock ? 8 : 9">
                                    <span> {{ moduleFiles.fileName }} </span>
                                  </v-col>
                                  <v-col
                                    v-if="
                                      (moduleFiles.lock === false && isStudent === false && permissionButton('ROLE_FILES_VIEW')) ||
                                        (moduleFiles.lock === true && isStudent === false && permissionButton('ROLE_FILES_VIEW')) ||
                                        (moduleFiles.lock === false && isStudent === true && permissionButton('ROLE_FILES_VIEW')) ||
                                        (moduleFiles.lock === false && isStudent === false && permissionButton('ROLE_FILES_LITE_VIEW')) ||
                                        (moduleFiles.lock === true && isStudent === false && permissionButton('ROLE_FILES_LITE_VIEW')) ||
                                        (moduleFiles.lock === false && isStudent === true && permissionButton('ROLE_FILES_LITE_VIEW'))
                                    "
                                    md="2"
                                    class="d-flex justify-space-around"
                                  >
                                    <div @click.prevent="linkDownload(moduleFiles)">
                                      <svg-icon icon="modules_download" width="30" height="30" class="mt-1 pointer" />
                                    </div>
                                    <div class="divider" />
                                    <div @click.prevent="previewFileTeacher(undefined, { moduleFiles })">
                                      <svg-icon icon="modules_view" width="30" height="30" class="mt-1 pointer" />
                                    </div>
                                  </v-col>
                                </v-row>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Assignment -->
                        <div v-if="item.moduleAssignments.length > 0" class="pa-5 mb-5 card-modules">
                          <strong class="header-content">{{ $t('menu.assignment') }} </strong>

                          <div class="mt-5">
                            <div v-for="moduleAssignments in item.moduleAssignments" :key="moduleAssignments.moduleAssignmentId">
                              <v-divider class="mb-3" />
                              <div class="d-block">
                                <v-row>
                                  <v-col md="1" align="center">
                                    <div class="pa-5">
                                      <svg-icon v-if="moduleAssignments.locked === true" icon="lock" class="red--text assigment-icon" />
                                      <svg-icon v-if="moduleAssignments.locked === false" icon="gembok" class="assigment-icon" />
                                    </div>
                                  </v-col>
                                  <v-col md="10">
                                    <div class="d-block mb-2">
                                      <strong class="d-inline" style="font-size: 12px;">
                                        {{ moduleAssignments.assignmentTitle }}
                                      </strong>
                                    </div>
                                    <div class="d-block">
                                      <div>
                                        <span style="font-size: 12px;">
                                          <span class="mr-3">
                                            {{ $t('form.datatype') }}:
                                            <strong style="color:#00BF63;" v-if="moduleAssignments.assignmentTypeId == 4"
                                              >{{ $t('content.assignment_item.manual_input') }}
                                            </strong>
                                            <strong style="color:#00BF63;" v-if="moduleAssignments.assignmentTypeId == 3">{{
                                              $t('content.assignment_item.attendance')
                                            }}</strong>
                                            <strong style="color:#00BF63;" v-if="moduleAssignments.assignmentTypeId == 2">{{
                                              $t('content.assignment_item.quiz')
                                            }}</strong>
                                            <strong style="color:#00BF63;" v-if="moduleAssignments.assignmentTypeId == 1">{{
                                              $t('content.assignment_item.upload_files')
                                            }}</strong>
                                          </span>
                                          |
                                          <span class="mr-3">
                                            {{ $t('form.status') }}:
                                            <strong v-if="moduleAssignments.submitted === false" style="color: #CE8800;">{{
                                              $t('content.no_submission')
                                            }}</strong>
                                            <strong v-if="moduleAssignments.submitted === true" style="color: #6DD400;">{{
                                              $t('content.submitted')
                                            }}</strong>
                                          </span>
                                          <span class="mr-3 ml-3">
                                            | {{ $t('content.available_from') }}:
                                            <strong>{{ moduleAssignments.availableFrom }}</strong>
                                            <strong v-if="moduleAssignments.availableFrom === null">-</strong></span
                                          >
                                          <span v-if="moduleAssignments.locked === false" class="ml-3 mr-3"
                                            >| {{ $t('content.lock_schedule') }} :
                                            <strong style="color: #E02020;">{{ moduleAssignments.availableFrom }}</strong>
                                            <strong style="color: #E02020;" v-if="moduleAssignments.availableFrom === null">-</strong>
                                          </span>
                                          <span v-if="moduleAssignments.locked === true" class="ml-3 mr-3"
                                            >{{ $t('content.unlock_schedule') }} :
                                            <strong style="color: #6DD400;">{{ moduleAssignments.availableFrom }}</strong>
                                            <strong style="color: #6DD400;" v-if="moduleAssignments.availableFrom === null">-</strong>
                                          </span>
                                          <span class="ml-3 mr-3">
                                            | {{ $t('content.due_date') }} :
                                            <strong style="color:#FA6400;">{{ moduleAssignments.dueDate }}</strong>
                                            <strong style="color:#FA6400;" v-if="moduleAssignments.dueDate === null">-</strong>
                                          </span>
                                          <span class="ml-3 mr-3">
                                            <span>| {{ $t('menu.score') }} : </span>
                                            <strong style="color:#00bf63;" v-if="!isStudent"> {{ moduleAssignments.totalPoint }}</strong>
                                            <span
                                              style="color:#00bf63;"
                                              v-if="
                                                (moduleAssignments.point === 0 && moduleAssignments.published === false && isStudent) ||
                                                  (moduleAssignments.excused && isStudent)
                                              "
                                            >
                                              - / {{ moduleAssignments.totalPoint }} Pts</span
                                            >
                                            <span
                                              style="color:#00bf63;"
                                              v-if="
                                                (moduleAssignments.point !== 0 && moduleAssignments.published === false && isStudent) ||
                                                  (moduleAssignments.excused && isStudent)
                                              "
                                            >
                                              {{ moduleAssignments.point }} / {{ moduleAssignments.totalPoint }} Pts</span
                                            >
                                          </span>
                                          <span class="ml-3 mr-1" v-if="!isStudent"> | {{ $t('information') }} :</span>
                                          <strong style="color:#6DD400;" v-if="!isStudent && moduleAssignments.published === true">{{
                                            $t('content.publish_score')
                                          }}</strong>
                                          <strong style="color:#E02020;" v-if="!isStudent && moduleAssignments.published === false">
                                            {{ $t('content.unpublish_score') }}</strong
                                          >
                                        </span>
                                      </div>
                                    </div>
                                  </v-col>
                                  <v-col
                                    v-if="
                                      (moduleAssignments.autoLock === false &&
                                        isStudent === false &&
                                        moduleAssignments.locked === false &&
                                        permissionButton('ROLE_ASSIGNMENT_VIEW')) ||
                                        (moduleAssignments.autoLock === true &&
                                          isStudent === false &&
                                          moduleAssignments.locked === false &&
                                          permissionButton('ROLE_ASSIGNMENT_VIEW')) ||
                                        (moduleAssignments.autoLock === false &&
                                          isStudent === false &&
                                          moduleAssignments.locked === true &&
                                          permissionButton('ROLE_ASSIGNMENT_VIEW')) ||
                                        (moduleAssignments.autoLock === false &&
                                          isStudent === true &&
                                          moduleAssignments.locked === false &&
                                          permissionButton('ROLE_ASSIGNMENT_VIEW')) ||
                                        (moduleAssignments.autoLock === false &&
                                          isStudent === false &&
                                          moduleAssignments.locked === false &&
                                          permissionButton('ROLE_ASSIGNMENT_LITE_VIEW')) ||
                                        (moduleAssignments.autoLock === true &&
                                          isStudent === false &&
                                          moduleAssignments.locked === false &&
                                          permissionButton('ROLE_ASSIGNMENT_LITE_VIEW')) ||
                                        (moduleAssignments.autoLock === false &&
                                          isStudent === false &&
                                          moduleAssignments.locked === true &&
                                          permissionButton('ROLE_ASSIGNMENT_LITE_VIEW')) ||
                                        (moduleAssignments.autoLock === false &&
                                          isStudent === true &&
                                          moduleAssignments.locked === false &&
                                          permissionButton('ROLE_ASSIGNMENT_LITE_VIEW'))
                                    "
                                    md="1"
                                    class="pa-5"
                                    align="center"
                                    @click="goViewAssignment(moduleAssignments)"
                                  >
                                    <svg-icon icon="modules_view" width="30" height="30" class="mt-1 pointer" />
                                  </v-col>
                                </v-row>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- pages -->
                        <div v-if="item.modulePages.length > 0" class="pa-5 mb-5 card-modules">
                          <strong class="header-content">{{ $t('content.pages') }}</strong>

                          <div class="mt-5">
                            <div v-for="modulePages in item.modulePages" :key="modulePages.modulePageId">
                              <v-divider class="mb-3" />
                              <div class="d-block">
                                <v-row>
                                  <v-col md="1" align="center">
                                    <svg-icon icon="modules_3" width="30" height="30" class="primary--text" />
                                  </v-col>
                                  <v-col md="10">
                                    <span> {{ modulePages.title }} </span>
                                  </v-col>
                                  <v-col
                                    v-if="permissionButton('ROLE_PAGES_VIEW') || permissionButton('ROLE_PAGES_LITE_VIEW')"
                                    md="1"
                                    @click="goViewPages(modulePages.pageId)"
                                  >
                                    <svg-icon icon="modules_view" width="30" height="30" class="mt-1 pointer" />
                                  </v-col>
                                </v-row>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </template>
              </slide-box>
            </div>
          </div>
          <!-- File Viewer -->
          <file-viewer :data="preview" v-model="dialogPreview" @onHide="hidePreview" />

          <NoData v-if="!datas.length" />
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
import SlideBox from '@/components/SlideBox';
import NoData from '@/components/table/NoData';
import moment from 'moment-timezone';
import FileViewer from '@/components/FileViewer';
import draggable from 'vuedraggable';
// import moment from 'moment-timezone';

export default {
  name: 'ModulesIndex',
  components: {
    BaseTitle,
    SlideBox,
    NoData,
    FileViewer,
    draggable
  },
  props: {
    isClass: {
      type: Boolean,
      default: false
    },
    isStudent: {
      type: Boolean,
      default: false
    }
  },
  sockets: {
    connect() {
      console.log('socket connected');
    },
    updateModule({ classId, courseId }) {
      const { classId: currentClassId, courseId: currentCourseId } = this.$route.params;
      if (classId == currentClassId && courseId == currentCourseId) {
        this.$store.dispatch('general/showSuccessNotification', { message: this.$t('alert.list_module') });
        setTimeout(() => {
          this.getData();
        }, 400);
      }
    },
    updateAssignment({ classId, courseId }) {
      const { classId: currentClassId, courseId: currentCourseId } = this.$route.params;
      if (classId == currentClassId && courseId == currentCourseId) {
        this.$store.dispatch('general/showSuccessNotification', { message: this.$t('alert.list_assignment') });
        setTimeout(() => {
          this.getData();
        }, 400);
      }
    },
    updateFile({ classId, courseId }) {
      const { classId: currentClassId, courseId: currentCourseId } = this.$route.params;
      if (classId == currentClassId && courseId == currentCourseId) {
        this.dialogInformation = false;
        this.dialogPreview = false;
        this.$store.dispatch('general/showSuccessNotification', { message: 'File Status Has Updated' });
        setTimeout(() => {
          this.getData();
        }, 400);
      }
    }
  },
  computed: {
    ...mapGetters({
      course: 'QuizTeacher/courses',
      classLevel: 'QuizTeacher/classLevel',
      permission: 'Auth/permission',
      user: 'Auth/user',
      nameCourse: 'CourseList/nameCourse'
    })
  },
  data: () => ({
    loadingButton: false,
    dialogDelete: false,
    loadingLoad: false,
    search: '',
    dataClass: '',
    datas: [],
    dateList: [],
    model: '',
    currentItem: '',
    gmt: '',
    dialogPreview: false,
    preview: {},
    titleData: ''
  }),
  methods: {
    checkAvailables(datas) {
      if (!datas) {
        this.$store.dispatch('general/showErrorNotification', { message: this.$t('alert.available_from_modules') });
      }
    },
    changeOrder() {
      this.loadingLoad = true;
      for (let index = 0; index < this.datas.length; index++) {
        const element = this.datas[index];
        element.order = index + 1;
      }
      this.$store
        .dispatch(`Modules/changeOrder`, {
          classroomId: this.$route.params.classId,
          courseId: this.$route.params.courseId,
          classSectionId: this.$route.params.classSectionId ? this.$route.params.classSectionId : '',
          datas: this.datas
        })
        .then(() => {
          this.getData();
        })
        .finally(() => (this.loadingLoad = false));
    },
    // File Viewer Teacher
    previewFileTeacher(e, { moduleFiles }) {
      this.dialogPreview = true;
      this.$set(this, 'preview', moduleFiles);
    },
    hidePreview() {
      this.dialogPreview = null;
      this.$set(this, 'preview', {});
    },
    permissionButton(push) {
      return this.permission.some(p => p === push) ?? false;
    },
    getProfile() {
      this.$store.dispatch('User/fetchProfile').then(res => {
        this.gmt = res.gmt;
      });
    },
    linkDownload(item) {
      window.location = `${process.env.VUE_APP_BASE_URL}api/file/download?key=${item.key}`;
    },
    getDataList() {
      const { classId, courseId } = this.$route.params;
      this.$store
        .dispatch('Assignment/fetchListFilter', {
          classId,
          courseId,
          classSectionId: this.$route.params.classSectionId ? this.$route.params.classSectionId : ''
        })
        .then(res => (this.dateList = res))
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
    },
    getData() {
      this.loadingLoad = true;
      this.$store
        .dispatch('Modules/fetchList', {
          classroomId: this.$route.params.classId,
          courseId: this.$route.params.courseId,
          classSectionId: this.$route.params.classSectionId ? this.$route.params.classSectionId : '',
          search: this.search
        })
        .then(res => {
          if (res) {
            res.forEach(datas => {
              if (datas.availableFrom) {
                var future = datas.availableFrom;

                if (this.gmt) {
                  var convertAwal = moment()
                    .tz(this.gmt)
                    .format('YYYY-MM-DD HH:mm');
                } else {
                  convertAwal = moment().format('YYYY-MM-DD HH:mm');
                }
                var convertAkhir = moment(future, 'DD-MM-YYYY HH:mm').format('YYYY-MM-DD HH:mm');
                if (convertAwal >= convertAkhir) {
                  datas.modulesDetail = true;
                } else {
                  datas.modulesDetail = false;
                }
              } else {
                datas.modulesDetail = true;
              }
            });
            this.datas = res;
          }
        })
        .finally(() => {
          this.loadingLoad = false;
        });
    },
    getDataClass() {
      if (!this.$route.params.classSectionId) {
        this.$store
          .dispatch('Class/fetchClassroomCourseName', { classId: this.$route.params.classId, courseId: this.$route.params.courseId })
          .then(res => {
            if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
              this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            } else {
              this.$store.dispatch('Class/fetchListLiteDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            }
          });
      } else {
        this.$store.dispatch('ClassSection/getListDetail', { classSectionId: this.$route.params.classSectionId }).then(res => {
          if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
            this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
              this.dataClass = resa;
              this.titleData = res.classroomName + ` ${res.numberClass}` + ` ( ${resa.yearPeriode} ) `;
            });
          }
        });
      }
    },
    addModules() {
      if (this.isClass && !this.isStudent) {
        if (!this.$route.params.classSectionId) {
          this.$router.push({ name: 'ModulesCreateClass' });
        } else {
          this.$router.push({ name: 'ModulesSectionCreateClass' });
        }
      } else if (this.isClass && this.isStudent) {
        if (!this.$route.params.classSectionId) {
          this.$router.push({ name: 'ModulesStudentCreateClass' });
        } else {
          this.$router.push({ name: 'ModulesStudentSectionCreateClass' });
        }
      } else {
        this.$router.push({ name: 'ModulesCreate' });
      }
    },
    goViewAssignment(item) {
      localStorage.setItem('backModules', true);
      if (this.isClass && !this.isStudent) {
        if (!this.$route.params.classSectionId) {
          this.$router.push({ name: 'TeacherAssignmentDetail', params: { assignmentId: item.assignmentId } });
        } else {
          this.$router.push({ name: 'TeacherAssignmentSectionDetail', params: { assignmentId: item.assignmentId } });
        }
      } else if (this.isClass && this.isStudent) {
        if (item.availableFrom) {
          var future = item.availableFrom;
          if (this.gmt) {
            var convertAwal = moment()
              .tz(this.gmt)
              .format('YYYY-MM-DD HH:mm');
          } else {
            convertAwal = moment().format('YYYY-MM-DD HH:mm');
          }
          var convertAkhir = moment(future).format('YYYY-MM-DD HH:mm');
          if (convertAwal >= convertAkhir) {
            localStorage.setItem('detailStudent', true);
            if (!this.$route.params.classSectionId) {
              this.$router.push({ name: 'StudentAssignmentDetail', params: { assignmentId: item.assignmentId } });
            } else {
              this.$router.push({ name: 'StudentSectionAssignmentDetail', params: { assignmentId: item.assignmentId } });
            }
          } else {
            this.$store.dispatch('general/showErrorNotification', { message: this.$t('alert.available_from') });
            localStorage.setItem('detailStudent', false);
          }
        } else {
          localStorage.setItem('detailStudent', true);
          if (!this.$route.params.classSectionId) {
            this.$router.push({ name: 'StudentAssignmentDetail', params: { assignmentId: item.assignmentId } });
          } else {
            this.$router.push({ name: 'StudentSectionAssignmentDetail', params: { assignmentId: item.assignmentId } });
          }
        }
      }
    },
    goViewPages(id) {
      localStorage.setItem('backModules', true);
      if (this.isClass && !this.isStudent) {
        if (!this.$route.params.classSectionId) {
          this.$router.push({ name: 'PagesViewClass', params: { id } });
        } else {
          this.$router.push({ name: 'PagesSectionViewClass', params: { id } });
        }
      } else if (this.isClass && this.isStudent) {
        if (!this.$route.params.classSectionId) {
          this.$router.push({ name: 'PagesStudentViewClass', params: { id } });
        } else {
          this.$router.push({ name: 'PagesStudentSectionViewClass', params: { id } });
        }
      }
    },
    goView(id) {
      if (this.isClass && !this.isStudent) {
        this.$router.push({ name: 'ModulesViewClass', params: { id } });
      } else if (this.isClass && this.isStudent) {
        this.$router.push({ name: 'ModulesStudentViewClass', params: { id } });
      } else {
        this.$router.push({ name: 'ModulesView', params: { id } });
      }
    },
    goEdit(id) {
      if (!this.$route.params.classSectionId) {
        this.$router.push({ name: 'ModulesEditClass', params: { id } });
      } else {
        this.$router.push({ name: 'ModulesSectionEditClass', params: { id } });
      }
    },
    goDelete(item) {
      this.dialogDelete = true;
      this.currentItem = item.moduleId;
    },
    deleteDetail() {
      if (!this.currentItem) return false;

      this.loadingButton = true;
      this.$store
        .dispatch('Modules/destroy', this.currentItem)
        .then(({ data }) => {
          this.$store.dispatch('general/showSuccessNotification', data);
          this.currentItem = null;
          this.getData();
          this.dialogDelete = false;
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.loadingButton = false));
    }
  },
  created() {
    this.getProfile();
    this.getData();
    if (this.isClass) {
      this.getDataClass();
    } else {
      localStorage.removeItem('courseName');
    }
  }
};
</script>

<style lang="scss" scoped>
.assignment {
  &-title {
    font-family: Montserrat;
    font-weight: bold;
    color: #6d6d6d;
    font-size: 18px;
  }

  &-head {
    font-family: Montserrat;
    font-weight: bold;
    color: #6d6d6d;
    font-size: 16px;
  }

  &-content {
    margin: 10px 20px 20px 20px;

    font-family: Montserrat;
    line-height: 16px;
    font-size: 12px;
  }
}
.section-header {
  border-radius: 4px 4px 0 0;

  &.active {
    background: #00bf63;
    .student-title {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}

.assigment-icon {
  width: 24px;
  height: 24px;
}

.border-item {
  border-bottom: 1px solid #dedede;
}
.text-dropdown {
  cursor: pointer;
  &-delete {
    color: red;
    cursor: pointer;
  }
}

.header-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 15px;
  line-height: 16px;
  width: 133px;
  text-align: left;
}

.pointer {
  cursor: pointer;
}
.bg-col {
  background-color: #b2ebd0;
  border-radius: 8px;
}

.card-modules {
  background-color: #ffffff;
  border-radius: 8px;
}
.divider {
  border: 1px solid #dedede;
  width: 1px;
  height: 28px;
}
.moving-card {
  opacity: 0.5;
  background: #f7fafc;
  border: 1px solid #4299e1;
}
</style>
